import { PHCOnboardingConstants } from "./PHCOnboardingConstants";

const PHCOnboardingActions = {};

PHCOnboardingActions.updatePHCOnboardingData = (payload = {}) => ({
    type: PHCOnboardingConstants.PHC_UPDATE_ONBOARDING_DATA,
    payload,
});


PHCOnboardingActions.getOnboardingData = () => ({
    type: PHCOnboardingConstants.PHC_ONBOARDING_DATA_SAGA,
});

export { PHCOnboardingActions };
